
export class CreateAdModels {
  private marketingReviewApplicationId!:number;
  private applicantRepCode!: string;
  private applicantBranchId!: string;
  private marketingTitle!: string;
  private marketingMaterialTypeId!: number;
  private targetRecepients!: string;
  private expectedDateOfDissemination!: string;
  private expectedCommentOfDissemination!: string;
  private modeOfDissemination!: string;
  private dateOfApplication!: string;
  private dateIssuedByMarketing!: string;
  private issuerRepCode!: string;
  private status!: string;
  private submittedBy!: string
  private submittedByRepCode!: string;
  private edmExpectedDate!: string;
  private referenceId!: number;
  

 


  constructor() { }

  getApplicantRepCode(): string {
    return this.applicantRepCode;
  }
  setApplicantRepCode(applicantRepCode: string) {
    this.applicantRepCode = applicantRepCode;
  }

  getApplicantBranchId(): string {
    return this.applicantBranchId;
  }
  setApplicantBranchId(applicantBranchId: string) {
    this.applicantBranchId = applicantBranchId;
  }

  getMarketingTitle(): string {
    return this.marketingTitle;
  }
  setMarketingTitle(marketingTitle: string) {
    this.marketingTitle = marketingTitle;
  }  

  getMarketingMaterialTypeId(): number {
    return this.marketingMaterialTypeId;
  } 
  setMarketingMaterialTypeId(marketingMaterialTypeId: number) {
    this.marketingMaterialTypeId = marketingMaterialTypeId;
  }

  getTargetRecepients(): string {
    return this.targetRecepients;
  } 
  setTargetRecepients(targetRecepients: string) {
    this.targetRecepients = targetRecepients;
  }

  getExpectedDateOfDissemination(): string {          
    return this.expectedDateOfDissemination;
  }   
  setExpectedDateOfDissemination(expectedDateOfDissemination: string) {
    this.expectedDateOfDissemination = expectedDateOfDissemination;
  }

  getExpectedCommentOfDissemination(): string {
    return this.expectedCommentOfDissemination;
  } 
  setExpectedCommentOfDissemination(expectedCommentOfDissemination: string) {
    this.expectedCommentOfDissemination = expectedCommentOfDissemination;
  } 

  getModeOfDissemination(): string {
    return this.modeOfDissemination;
  } 
  setModeOfDissemination(modeOfDissemination: string) {
    this.modeOfDissemination = modeOfDissemination;
  } 

  getDateOfApplication(): string {
    return this.dateOfApplication;
  }
  setDateOfApplication(dateOfApplication: string) {
    this.dateOfApplication = dateOfApplication;
  }

  getDateIssuedByMarketing(): string {
    return this.dateIssuedByMarketing;
  }   
  setDateIssuedByMarketing(dateIssuedByMarketing: string) {
    this.dateIssuedByMarketing = dateIssuedByMarketing;
  } 

  getIssuerRepCode(): string {
    return this.issuerRepCode;
  } 
  setIssuerRepCode(issuerRepCode: string) {     
  this.issuerRepCode = issuerRepCode;   
  }

  getStatus(): string {
    return this.status;
  } 
  setStatus(status: string) {
    this.status = status;
  }

  getSubmittedBy(): string {
    return this.submittedBy;
  } 
  setSubmittedBy(submittedBy: string) {
    this.submittedBy = submittedBy;
  } 

  getSubmittedByRepCode(): string {     
    return this.submittedByRepCode;
  }
  setSubmittedByRepCode(submittedByRepCode: string) {   
    this.submittedByRepCode = submittedByRepCode;   
  }

  getEdmExpectedDate(): string {
    return this.edmExpectedDate;
  }
  setEdmExpectedDate(edmExpectedDate: string) {
    this.edmExpectedDate = edmExpectedDate;
  }

  getReferenceId(): number {
    return this.referenceId;
  }
  setReferenceId(referenceId: number) {
    this.referenceId = referenceId;
  }

  getMarketingReviewApplicationId(): number {
  return this.marketingReviewApplicationId;
}

setMarketingReviewApplicationId(marketingReviewApplicationId: number) {
  this.marketingReviewApplicationId = marketingReviewApplicationId;
}


  toString() {
    return JSON.stringify({
      applicantRepCode: this.getApplicantRepCode(),
      applicantBranchId: this.getApplicantBranchId(),
      marketingTitle: this.getMarketingTitle(),
      marketingMaterialTypeId: this.getMarketingMaterialTypeId(),
      targetRecepients: this.getTargetRecepients(),
      expectedDateOfDissemination: this.getExpectedDateOfDissemination(),
      expectedCommentOfDissemination: this.getExpectedCommentOfDissemination(),
      modeOfDissemination: this.getModeOfDissemination(),
      dateOfApplication: this.getDateOfApplication(),
      dateIssuedByMarketing: this.getDateIssuedByMarketing(),
      issuerRepCode: this.getIssuerRepCode(),
      status: this.getStatus(),
      submittedBy: this.getSubmittedBy(),
      submittedByRepCode: this.getSubmittedByRepCode(),
      edmExpectedDate: this.getEdmExpectedDate(),
      referenceId: this.getReferenceId(),
      marketingReviewApplicationId: this.getMarketingReviewApplicationId(),
    });
  }

  
}



